import { createApiCall } from 'lib/base';

const SEND_ADMIN_NOTIFICATION = 'SEND_ADMIN_NOTIFICATION';

const sendNotificationApi = createApiCall<{
  user_ids: string[];
  title: string;
  body: string;
  screen_name?: string;
  id?: string;
}>(SEND_ADMIN_NOTIFICATION, payload => ({
  endpoint: 'api/admin/notifications/send',
  method: 'POST',
  body: payload,
}));

export default sendNotificationApi;
